import { AppConfig } from '@nai-libs/shared/data-access/src';

export const environment: AppConfig = {
  production: false,
  appName: 'macrosad-family',
  domain: 'ubikare.io',
  baseUrl: 'https://naiha.macrosad.test.ubikare.io',
  apiUrl: 'https://naiha.macrosad.test.ubikare.io/api-nf/',
  
  availableLanguages: ['es','eu',],
  defaultLanguage: 'es',
  features: {
    edercare: false,

    wall: true,
    activities: true,
    articles: false,
    clockIn: true,
    taskList: true,
    shortcuts: undefined,
    goals: undefined,
    incidenceReport: false,
    observations: true,

    taskForm: true,
    symptoms: undefined,
    calendar: true,
    CMDForm: false,
    DGI: false,
    healthRecord: undefined,
    medication: undefined,
    PAECH: false,

    healthMonitor: true,
    physicalEducation: false,
    danceTherapy: false,
    neuro: false,
    homeAccessibility: false,
    educationalProgram: true,
    nutrition: undefined,
    zaintzaQuiz: false,
    personalProgress: true,
    editPlan: false,

    videoconsultations: false,
    respiro: false,
    documents: true,
    shop: false,
    buyAndSell: false,
    professionals: true,

    faq: false,
    chats: true,
    contact: false,
    community: false,
    satisfactionSurvey: false,

    members: false,
    statistics: true,
    notifications: true,
    switchUser: false,

    editAvatar: true,
    editProfile: true,
    changePassword: true,
    changeLanguage: true,
    passwordRecovery: true,

    switchServiceReceiver: true,
    geolocatedClockIn: true,
  },
};

